import { AuthErrorEnum } from '@/constants/enums/AuthErrorEnum';
import { RouteEnum } from '@/constants/enums/RouteEnum';
import type { AuthData } from '@/models/interface/auth';
import { api } from '@/services';
import { useUserStore } from '@/stores/user';
import type { ApiDataResponse } from '@/utils/api';
import { isApiSuccess, resolveApiData } from '@/utils/api/functions';
import { jwtDecode } from 'jwt-decode';
import { useRouter } from 'vue-router';

const user = useUserStore();

export const useThirdPartVerify = () => {
  const router = useRouter();
  const { openToast } = useToast();

  const verifyCodeHandler = (res: ApiDataResponse<AuthData>) => {
    const data = resolveApiData(res);

    if (isApiSuccess(res)) {
      //已經用第三方註冊過
      user.token = data.responseText;
      user.isFirstLogin = true;
      user.isLogin = true;

      window.localStorage.removeItem('from-third-party-email');
      window.localStorage.removeItem('from-third-party-id');
      window.localStorage.removeItem('from-third-party-type');
      router.push({ name: RouteEnum.Index });
      return;
    }

    window.localStorage.setItem('from-third-party-email', data.email);
    window.localStorage.setItem('from-third-party-id', data.thirdPartyId);
    window.localStorage.setItem('from-third-party-type', `${data.thirdPartyType}`);

    //因三方註冊後一定要手機，所以 4058, 4059, 4067 要不顯示錯誤訊息
    const errorKey = res.data.errorCode?.toString();
    if (errorKey && errorKey in AuthErrorEnum && !['-4058', '-4059', '-4067'].includes(errorKey)) {
      openToast('error', AuthErrorEnum[errorKey as keyof typeof AuthErrorEnum]);
    }
  };

  const googleVerifyHandler = async (token: string) => {
    const res = await api.auth.googleVerify(token);
    verifyCodeHandler(res);
  };

  const metaVerifyHandler = async (token: string) => {
    const res = await api.auth.metaVerify(token);
    verifyCodeHandler(res);
  };

  const lineVerifyHandler = async (code: string) => {
    const params = new URLSearchParams();
    params.append('grant_type', 'authorization_code');
    params.append('code', code);
    params.append('redirect_uri', import.meta.env.VITE_LINE_REDIRECTURI);
    params.append('client_id', import.meta.env.VITE_LINE_CLIENTID);
    params.append('client_secret', import.meta.env.VITE_LINE_CLIENTSECRET);
    try {
      const response = await fetch(`https://api.line.me/oauth2/v2.1/token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: params
      });
      if (!response.ok) {
        throw new Error();
      }
      const data = await response.json();
      // const id_token = jwtDecode(data.id_token);
      // localStorage.setItem('from-third-party-type', '3');
      // localStorage.setItem('from-third-party-id', id_token?.sub);
      // if (id_token.email !== '') localStorage.setItem('from-third-party-email', id_token.email);

      const res = await api.auth.lineVerify(data.access_token);
      verifyCodeHandler(res);
    } catch {
      console.log('error');
    }
  };

  const appleVerifyHandler = async (token: string) => {
    const res = await api.auth.appleVerify(token);
    verifyCodeHandler(res);
  };

  return { googleVerifyHandler, metaVerifyHandler, lineVerifyHandler, appleVerifyHandler };
};
